import Vue from 'vue'
import config from './config.js'
import Utils from './utils.js'

const ThingsService = {

  create: (thing) => {
    let create_request = () => {
      console.log('creating thing: ' + JSON.stringify(thing, undefined, 2))
      return Vue.http.post(config.apiUrl() + '/things/', thing)
    }
    return Utils.generic_request(create_request)
  },

  fetch: (thingId, params = {}) => {
    return Utils.generic_request(() => {
      console.log('fetching thing: ' + JSON.stringify(thingId, undefined, 2))
      return Vue.http.get(`${
        config.apiUrl()}/things/${thingId}`,
        { params }
      )
    })
  },

  fetchLatestSignal: (thingId, params = {}) => {
    return Utils.generic_request(() => {
      console.log('fetching thing latest signal: ' + JSON.stringify(thingId, undefined, 2))
      return Vue.http.get(`${
        config.apiUrl()}/things/${thingId}/signals/latest`,
        { params }
      )
    })
  },

  attach: (parentThingId, childThingId) => {
    let attach_request = () => {
      console.log('attaching childThingId: ' +  childThingId + ' to parentThingId: '+ parentThingId)
      let child_attach_json = {
          id : childThingId
      };
      return Vue.http.post(config.apiUrl() + "/things/" + parentThingId + "/things/", child_attach_json)
    }
    return Utils.generic_request(attach_request)
  },

  patch: (thingId, changeSet) => {
    let patch_request = () => {
      console.log('updating thing: ' + JSON.stringify(thingId, undefined, 2))
      return Vue.http.patch(`${config.apiUrl()}/things/${thingId}/info`, changeSet)
    }
    return Utils.generic_request(patch_request)
  },

  delete: (thingId) => {
    let delete_request = () => {
      console.log('deleting thing: ' + JSON.stringify(thingId, undefined, 2))
      return Vue.http.delete(config.apiUrl() + '/things/' + thingId)
    }
    return Utils.generic_request(delete_request)
  },

  findAccountThings: (account_id, parameters = {}) => {
    let find_account_things_request = () => {
      console.log('findAccountThings account_id: ' + account_id)
      const _parameters = Object.assign({ account_id }, parameters)
      return Vue.http.get(`${config.apiUrl()}/things`, { params: _parameters })
    }
    return Utils.generic_request(find_account_things_request)

  },

  thingLocations: (thing_id, limit, page) => {
    let things_locations_request = () => {
      console.log('Find Locations for thing: ' + thing_id)
      return Vue.http.get(config.apiUrl() + '/things/' + thing_id + '/locations?_limit=' + limit + '&_page=' + page)
    }
    return Utils.generic_request(things_locations_request)
  },

  thingSignals: (thingId, parameters) => (
    Utils.generic_request(() =>
      Vue.http.get(
        `${config.apiUrl()}/things/${thingId}/signals`,
        { params: parameters }
    ))
  ),

  // migrateThing: (destination_account_id, thing) => {
  //   let migrate_things_request = () => {
  //     console.log('migrating ' + JSON.stringify(thing,undefined,2) + ' to account ' + destination_account_id)
  //   }
  //   return Utils.generic_request(migrate_things_request)
  // },

  /**
   * @author Sandoval Lucas
   *
   * @description Sirve para limpiar las cosas que no tiene un delete en la web (gps, panel, etc)
   */
  cleanAllThings: async (account_id) => {
    let clean_all_things_request = async () => {
      let allthings = await Vue.http.get(config.apiUrl() + '/things?account_id=' + account_id)
      allthings.body.map(async thing => {
        let deleteResponse = await Vue.http.delete(config.apiUrl() + '/things/' + thing.id)
      })
    }
    return Utils.generic_request(clean_all_things_request)
  },

  findVehiculeByDomain: (domain) => {
    let find_vehicle_by_domain_request = () => {
      var domainSerach = domain.toUpperCase()
      console.log('find cars by domain ' + domainSerach)
      return Vue.http.get(config.apiUrl() + '/things/?_include=child_things&info.domain=' + domainSerach)
    }
    return Utils.generic_request(find_vehicle_by_domain_request)
  },

  findVehiculeBySerial: (serial) => Utils.generic_request(
    async () => {
      const gpsResult = await Vue.http.get(config.apiUrl() + '/things/?_include=child_things&info.serial_number=' + serial)
      if (gpsResult.body.length > 0) {
        const vehicleResult = await Vue.http.get(`${config.apiUrl()}/things/${gpsResult.data[0].parent_id}?_include=child_things`)
        return vehicleResult.body
      }

    }
  ),

  getActions: (thingId, query) => Utils.generic_request(
    () => Vue.http.get(`${config.apiUrl()}/things/${thingId}/actions/?_q=${query}`)
      .then(x => x.body)
  ),

  getAction: (thingId, executionId) => Utils.generic_request(
    () => Vue.http.get(`${config.apiUrl()}/things/${thingId}/actions/${executionId}`)
      .then(response => response.data)
  ),

  executeAction: (thingId, actionType, body = {}) => Utils.generic_request(
      () => Vue.http.post(`${config.apiUrl()}/things/${thingId}/actions/${actionType}`, body)
      .then(response => response.body)
  )
}
export default ThingsService



// WEBPACK FOOTER //
// ./src/thingsService.js